import React from 'react';

type BadgeVariant = 'success' | 'warning' | 'error' | 'info';

interface BadgeProps {
  variant: BadgeVariant;
  children: React.ReactNode;
}

const VARIANT_STYLES: Record<BadgeVariant, { bg: string; color: string }> = {
  success: { bg: 'rgba(16, 185, 129, 0.15)', color: '#10B981' },
  warning: { bg: 'rgba(245, 158, 11, 0.15)', color: '#F59E0B' },
  error: { bg: 'rgba(239, 68, 68, 0.15)', color: '#EF4444' },
  info: { bg: 'rgba(59, 130, 246, 0.15)', color: '#3B82F6' },
};

export const Badge: React.FC<BadgeProps> = ({ variant, children }) => {
  const { bg, color } = VARIANT_STYLES[variant];

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        padding: '2px 8px',
        fontSize: '0.65rem',
        fontWeight: 700,
        textTransform: 'uppercase',
        letterSpacing: '0.05em',
        borderRadius: 9999,
        backgroundColor: bg,
        color,
        lineHeight: 1.6,
      }}
    >
      {children}
    </span>
  );
};
